<ng-template [ngIf]="!item">...</ng-template>

<ng-container [ngSwitch]="contentType">

  <app-lesson-card-mini
    *ngSwitchCase="'lesson'"
    [item]="item"
    [active]="active"
    [linkEnable]="linkEnable"
    [format]="format"
    [infinity]="infinity"
    [attr.data-test]="'lesson_card_mini'">
  </app-lesson-card-mini>

  <app-video-card-mini
    *ngSwitchCase="'video'"
    [item]="item"
    [active]="active"
    [linkEnable]="linkEnable"
    [format]="format"
    [infinity]="infinity">
  </app-video-card-mini>

  <app-audio-card-mini
    *ngSwitchCase="'audio'"
    [item]="item"
    [active]="active"
    [linkEnable]="linkEnable"
    [format]="format"
    [infinity]="infinity">
  </app-audio-card-mini>

  <app-image-card-mini
    *ngSwitchCase="'image'"
    [item]="item"
    [active]="active"
    [linkEnable]="linkEnable"
    [format]="format"
    [infinity]="infinity">
  </app-image-card-mini>

  <app-article-card-mini
    *ngSwitchCase="'article'"
    [item]="item"
    [active]="active"
    [linkEnable]="linkEnable"
    [format]="format"
    [infinity]="infinity">
  </app-article-card-mini>

  <app-vocabulary-card-mini
    *ngSwitchCase="'vocabulary'"
    [item]="item"
    [active]="active"
    [linkEnable]="linkEnable"
    [format]="format"
    [infinity]="infinity">
  </app-vocabulary-card-mini>

  <ng-template [ngIf]="debug$ | async">
    <div (click)="reloadRating()" class="clickable">
      <p><strong>Популярность:</strong> {{ debugPopularity }}</p>
      <p><strong>Популярность за неделю:</strong> {{ debugPopularityByPeriod }}</p>
      <p><strong>Параметры:</strong> {{ debugParams | json }}</p>
      <p><strong>Статистика урока:</strong> {{ debugStats | json }}</p>  
    </div>
  </ng-template>

</ng-container>
